import { useState, useEffect, useCallback } from 'react';
import { partnerService } from '@/services/partner';
import { Partner, PartnerQueryParams } from '@/types/partner';

export const usePartner = (params?: PartnerQueryParams) => {
  const [partners, setPartners] = useState<Partner[]>([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchPartners = useCallback(async () => {
    try {
      setLoading(true);
      const defaultParams: PartnerQueryParams = {
        offset: 0,
        limit: 100,
        ...params,
      };
      const response = await partnerService.getAll(defaultParams);
      setPartners(response.data || []);
      setTotal(response.total || 0);
      setError(null);
    } catch {
      setError('Failed to load partners');
    } finally {
      setLoading(false);
    }
  }, [params?.offset, params?.limit, params?.q]);

  useEffect(() => {
    fetchPartners();
  }, [fetchPartners]);

  return { partners, total, loading, error, refetch: fetchPartners };
};